export default __webpack_public_path__ + "static/media/cto-normal.6ebe3373.svg";